/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsListSetupTasks } from "../funcs/organizationsListSetupTasks.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListSetupTasksResult } from "../models/components/listsetuptasksresult.js";
import {
  ListSetupTasksRequest,
  ListSetupTasksSecurity,
} from "../models/operations/listsetuptasks.js";
import { unwrapAsync } from "../types/fp.js";
export type ListSetupTasksQueryData = ListSetupTasksResult;

export function prefetchListSetupTasks(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSetupTasksRequest | undefined,
  security?: ListSetupTasksSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListSetupTasksQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListSetupTasksQuery(
  client$: GramCore,
  request?: ListSetupTasksRequest | undefined,
  security?: ListSetupTasksSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListSetupTasksQueryData>;
} {
  return {
    queryKey: queryKeyListSetupTasks({
      includeHidden: request?.includeHidden,
      gramSession: request?.gramSession,
    }),
    queryFn: async function listSetupTasksQueryFn(
      ctx,
    ): Promise<ListSetupTasksQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationsListSetupTasks(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListSetupTasks(
  parameters: {
    includeHidden?: boolean | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "organizations", "listSetupTasks", parameters];
}
